import { Heading, Separator, Text, VStack } from "@chakra-ui/react";
import React from "react";

interface FormContainerProps {
  children: React.ReactNode;
  maxWidth?: string;
  heading: string;
  description?: string;
}

function FormContainer({
  children,
  maxWidth = "500px",
  heading,
  description,
  ...props
}: FormContainerProps) {
  return (
    <VStack
      p={5}
      borderWidth={{ base: 0, md: 1 }}
      borderRadius="lg"
      width="600px"
      maxWidth={maxWidth}
      gap={4}
      {...props}
    >
      <VStack>
        <Heading size={"2xl"}>{heading}</Heading>
        <Text fontSize={"sm"} opacity={0.5}>{description}</Text>
      </VStack>
      <Separator my={2} w={"full"} />
      {children}
    </VStack>
  );
}

export default FormContainer;
